import { render, staticRenderFns } from "./agentSetMeal.vue?vue&type=template&id=0b945a28&"
import script from "./agentSetMeal.vue?vue&type=script&lang=js&"
export * from "./agentSetMeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports